var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.18 7.689a.614.614 0 0 1 .436-.189.593.593 0 0 1 .436.189L12 14.947l6.948-7.258a.615.615 0 0 1 .436-.189.594.594 0 0 1 .436.189.647.647 0 0 1 .18.455.668.668 0 0 1-.18.455l-7.384 7.712A.616.616 0 0 1 12 16.5a.593.593 0 0 1-.435-.189L4.18 8.6A.645.645 0 0 1 4 8.144a.668.668 0 0 1 .18-.455Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;